export default __webpack_public_path__ + "static/media/no.e9e6f88d.svg";